const ratio = (origH, origW, newW) => {
    return (origH / origW) * newW
}

export default ratio
